import taiwo from '../../assets/taiwo.png';
import queen from '../../assets/queen.jpg';
import casi from '../../assets/casi.png';
import emmanual from '../../assets/emmanuel.jpg';
import bose from '../../assets/bose.jpg';
import sarah from '../../assets/sarah.webp';

const Content = [
  {
    id: 'testify1',
    content:
      'With a Homely Eats meal, you can serve delectable, home-cooked meals to your family and friends in any location, anytime. anyday!',
    image: taiwo,
    name: 'Taiwo Jazz',
    location: 'Ogun',
    rating: '⭐⭐⭐⭐'
  },
  {
    id: 'testify2',
    content:
      "Be it a small gathering of friends or a large event with hundreds of people, you'll always be prepared. whether you're at home or on the go.",
    image: queen,
    name: 'Queen Bryant',
    location: 'Lagos',
    rating: '⭐⭐⭐⭐⭐'
  },
  {
    id: 'testify3',
    content:
      'No need to worry about any of this anymore with your app. Homely Eats are made with the highest quality ingredients for you and your family.',
    image: casi,
    name: 'Casi Henry',
    location: 'Edo',
    rating: '⭐⭐⭐'
  },
  {
    id: 'testify4',
    content:
      'This is the very best food order app i have seen in recent time, there food is so delicious and there delivery is so on point. Very fast and reliable, buy there food and you will be glad you did.',
    image: emmanual,
    name: 'Emma Tobby',
    location: 'Abuja',
    rating: '⭐⭐⭐⭐⭐'
  },
  {
    id: 'testify5',
    content: "Simply the best i've seen in recent times. Keep it up",
    image: bose,
    name: 'Bose Olamide',
    location: 'Ibadan',
    rating: '⭐⭐⭐⭐'
  },
  {
    id: 'testify6',
    content:
      'Your food are so yummy, i will recomend to my friends. Thanks for making my say.',
    image: sarah,
    name: 'Sarah Damsel',
    location: 'Lagos',
    rating: '⭐⭐⭐⭐⭐'
  }
];

export default Content;
